/* eslint-disable */
import Vue from 'vue';
import axios from 'axios';
import 'promise-polyfill/src/polyfill';

document.addEventListener('DOMContentLoaded', function () {

  let store = {
    searchString: "",
    perPage: 100,
    paged: 1,
    isFiltered: false,
    results: null,
    filter: {
      topics: []
    }
  };

  const topic = Vue.component('topic', {
    props: {
      items: Array,
    },
    data: function() {
      return {
        dataFeed: null,
        totalPages: null,
        totalResults: null,
        index: null,
        shared: store,
      };
    },
    template: '#topic',
    methods: {
      getResults() {
        var keyword = '';
        if (this.shared.searchString.length > 0) {
          keyword = this.shared.searchString;
        }
        axios
          .get('/wp-json/wp/v2/faq?include=' + this.items.join() + '&per_page=' + this.shared.perPage + '&_fields=id,title,content&page=' + this.shared.paged + '&search=' + keyword)
          .then(response => {
            this.dataFeed = response.data;
            this.totalPages = response.headers['x-wp-totalpages'];
            this.totalResults = response.headers['x-wp-total'];
          })
          .catch(error => console.log(error));
      }
    },
    mounted() {
      this.getResults();
    },
    watch: {
      shared: {
        handler: function(value) {
          this.paged = 1;
          this.getResults();
        },
        deep: true
      },
      paged(after, before) {
        this.getResults();
      }
    }
  });

  const accordion = Vue.component('accordion', {
    props: {
      item: Object,
    },
    data: function () {
      return {
        isOpen: false,
      };
    },
    template: '#accordion',
    methods: {
      toggleAccordion: function (item) {
        if (!this.isOpen) {
          this.openAccordion();
        } else {
          this.closeAccordion();
        }
        this.isOpen = !this.isOpen;
      },
      openAccordion: function () {
        let _this = this;

        // close all open accordions
        this.$parent.$children.forEach(c => {
          if (c !== _this && c.isOpen) {
            c.isOpen = false;
            c.closeAccordion();
          }
        });

        this.$refs.accordionElement.classList.add('is-open');
        this.$refs.accordionReveal.style.height = 'auto';

        let height = this.$refs.accordionReveal.clientHeight + 'px';
        this.$refs.accordionReveal.style.height = '0px';

        setTimeout(function () {
          _this.$refs.accordionReveal.style.height = height;
        }, 0);
      },
      closeAccordion: function () {
        let _this = this;
        this.$refs.accordionReveal.style.height = '0px';
        this.$refs.accordionReveal.addEventListener('transitionend', function cb(e) {
          _this.$refs.accordionElement.classList.remove('is-open');
          e.currentTarget.removeEventListener(e.type, cb);
        });
      }
    },
  });

  const faqsSearchApp = new Vue({
    el: '#faqsSearch',
    data: store,
    methods: {
      filterTopics(id) {
        var newItem = id;
        var array = this.filter.topics;

        array.indexOf(newItem) === -1 ? array.push(newItem) : array.splice( array.indexOf(id), 1);

        array.length > 0 ? this.isFiltered = true : this.isFiltered = false;
      },
      cancel() {
        // let's make the field empty
        this.searchString = '';
      },
    },
    mounted() {
      this.results = this.$children.length

      this.$children.forEach((item, index) => {
        item.index = index
      })
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/faqs_search.js